import {Component, Input} from '@angular/core';
import {ResizeDetectionService} from "../../../services/resize-detection.service";
import {NgClass, NgIf} from "@angular/common";

@Component({
    selector: 'app-trustpilot-card',
    templateUrl: './trustpilot-card.component.html',
    styleUrls: ['./trustpilot-card.component.scss'],
    standalone: true,
    imports: [ NgClass, NgIf ]
})
export class TrustpilotCardComponent {
    isTablet: boolean = false;
    isMobile: boolean = false;
    isDesktop: boolean = false;
    deviceClass: string = '';

    @Input('text') text:string = "";
    @Input('label') label:string = "";


    constructor(private sizedetection: ResizeDetectionService) {}

    ngOnInit() {
        this.sizedetection.refreshSize();
        this.sizedetection.sizeCondition$.subscribe(data => {
            this.isDesktop = data.isDesktop;
            this.isTablet = data.isTablet;
            this.isMobile = data.isMobile;

            if(this.isDesktop) {
                this.deviceClass = 'desktop';
            }

            if(this.isTablet) {
                this.deviceClass = 'tablet';
            }

            if(this.isMobile) {
                this.deviceClass = 'mobile';
            }

            //console.log('tp-card', this.isMobile, this.isTablet, this.isDesktop)
        });
    }
}
